import image from '../img/pin.svg'
import image_pin from '../img/row-pin.svg'
import $ from "jquery";

export default function (search_by) {
	const
		container 	= document.getElementById( "google-map" ),
		infowindow  = new google.maps.InfoWindow(),
		service     = new google.maps.DistanceMatrixService(),
		sellerType = document.querySelectorAll('.seller-type');
	let
		map,
		origins     = [],
		destination = search_by[2].value,
		form        = $( 'form.points-search-section__form' ),
		location    = form.find( '.-js-set-location' ).val(),
		markers     = [],
		filter = [];

	if ( ! container) {
		return;
	}

	// append form in search results
	$( '.points-search-section__form' ).appendTo( '.-js-append-search-form' );
	$( '.points-search-section__form .result-row' ).removeClass().addClass( 'result-row-append' );
	$( '.points-search-section__form .columns' ).removeClass().addClass( 'result-columns' );

	if (googleMapPins.length === 0) {

		// reset search and show error message if no results

		$( '.-js-append-search-status' ).text( 'Nie znaleziono wyników' ).addClass( 'active' );
		form[0].reset();
		return;
	} else {
		$( '.-js-append-search-status' ).removeClass( 'active' ).text( '' );
	}

	$.get(`https://maps.googleapis.com/maps/api/geocode/json?&address=${location}&key=${acf_option.google_api_key}&ver=1623319620`,
		function (data) {
			map = new google.maps.Map(
				container,
				{
					zoom: 13,
					center: {lat: data.results[0].geometry.location.lat, lng: data.results[0].geometry.location.lng},
				}
			);

			function placeMarker(loc) {

				const marker = new google.maps.Marker(
					{
						position : new google.maps.LatLng( loc.google_adres.lat, loc.google_adres.lng ),
						map : map,
						icon : image,
						category: loc.post_terms.slugs
					}
				);

				origins.push( loc.google_adres.address )
				service.getDistanceMatrix(
					{
						origins: origins,
						destinations: [destination],
						travelMode: 'DRIVING',
						},
					setDistance
				);

				function setDistance() {
					google.maps.event.addListener(
						marker,
						'click',
						function(){
							infowindow.close();
							infowindow.open( map, marker );
							infowindow.setContent(`
								<div class="search-result search-result--map" data-terms="${ loc.post_terms.slugs }">
									<div class="search-result__col search-result__col--left">
										<div class="search-result__pin-container">
											<img src="${image_pin}" alt="" class="search-result__pin">
										</div>
										<div class="search-result__texts">
											<div class="search-result__name">
											   ${loc.tytul}
											</div>
											<div class="search-result__address">
											   ${loc.google_adres.address}
											</div>
											<div class="search-result__col search-result__col--right">
												<a target="_blank" class="button button--text button--text-slim search-result__button" href="${loc.link_directions}">wyznacz trasę</a>
												<div class="search-result__distance">
													${loc.distance} km
												</div>
												<div class="search-result__type">${ loc.post_terms.names }</div>
											</div>
										</div>
									</div>
								</div>
							`)

						}
					);

				}
				markers.push(marker);
			}

			// ITERATE ALL LOCATIONS. Pass every location to placeMarker
			googleMapPins.forEach( placeMarker );
			const row_results = document.querySelectorAll('.search-results__rows .search-result')
			row_results.forEach(function (el) {
				const lat = parseFloat(el.getAttribute('data-lat'))
				const lng = parseFloat(el.getAttribute('data-lng'))
				el.addEventListener('click', function () {
					map.setCenter({
						lat : lat,
						lng : lng -0.03
					});
				})
			})

			function sellersFilter (el) {
				let category = el.children[0].name;
				if( filter.includes(category) ) {
					filter = filter.filter(item => item !== category)
				} else {
					filter.push(category)
				}
				$('.search-result').removeClass('active')
				markers.forEach(function (marker) {
					marker.setMap(null)
					let categories = marker.category.split(', ');
					let filterResult = false;
					categories.forEach(function (category) {
						if (filter.includes(category) || filter.length === 0) {
							filterResult = true
						}
					})
					if (filterResult) {
						marker.setMap(map)
						$(`.search-result[data-categories="${marker.category}"]`).each(function () {
							this.classList.add('active')
						})
					}
				})
			}
			sellerType.forEach(function (el) {
				let input = $(el).find('input');
				if($(input).attr('name') === 'dealer') {
					$(input).prop("checked", true)
					sellersFilter(el)
				}
				el.addEventListener('click', function () { sellersFilter(el) } )
			})
		}
	)
}
